import React, { useState } from 'react';
import { Link } from "react-router-dom";

import StarRatings from 'react-star-ratings';
import b1 from "../../assets/images/b1.jpg"
import profile1 from "../../assets/images/profile1.jpg"
import classes from "./UserProfile.module.css"
import ImageUploader from 'react-images-upload';
import { MapContainer, TileLayer, useMap,Marker,Popup } from 'react-leaflet'

export const UserProfileNew=()=>{
     
       const [markerPosition,setmarkerPosition] = useState(['51.505','-0.09'])
       const position = [51.505, -0.09]
    return(
        <>
        <div className="descriptionPage" >
          <div className='conatiner-fluid mt-5 m-0 pt-5 p-0' style={{minHeight:'75vh'}}>
              <div className='row m-0 p-0 d-flex flex-column justify-content-center align-items-center'>
                 <div className='col-7 col-sm-6 col-md-5 col-lg-4 d-flex flex-column shadow pb-2'>
                   <label className='mb-2 mt-2 text-center ' style={{fontSize:'2rem'}}>Update Profile</label>
                  <label className='mb-0'>Enter Name</label>
                  <input className='mb-2 p-1 fs-6' placeholder='Enter your name please.....' style={{border:'1px solid lightgrey',borderRadius:'5px',outline:'none'}}></input>
                  <label className='mb-0'>Enter Email</label>
                  <input className='mb-2 p-1 fs-6' placeholder='Enter your email address please.....' style={{border:'1px solid lightgrey',borderRadius:'5px',outline:'none'}}></input>
                  <label className='mb-0'>Enter Mobile Number</label>
                  <input className='mb-2 p-1 fs-6' placeholder='Enter your mobile number please.....' style={{border:'1px solid lightgrey',borderRadius:'5px',outline:'none'}}></input>
                  <label className='mb-0'>Upload Profile Picture</label>
                  {/* <input placeholder='Enter your email address please.....'></input>
                   */}
                   <ImageUploader
                     withIcon={false}
                     buttonText='Upload photo'
                    //  onChange={onDrop}
                     imgExtension={['.jpg', '.gif', '.png']}
                     maxFileSize={5242880}
                     withPreview={true}
                     buttonClassName="round-button width-200"
                     singleImage={true}
                    />
                    
                 <div className='row m-0 mb-2 p-0 d-flex flex-column justify-content-center align-items-center'>
                 <button className="round-button width-200 ">Update</button>
                 {/* <div className='conatiner m-0 p-0 border border-2 border-danger'>
                              <MapContainer center={[51.505, -0.09]} zoom={13} scrollWheelZoom={false}>
               <TileLayer
                 attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                 url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
               />
               <Marker position={[51.505, -0.09]}>
                 <Popup>
                   A pretty CSS3 popup. <br /> Easily customizable.
                 </Popup>
               </Marker>
             </MapContainer>
                 </div> */}
                 </div>   
                 </div>
              </div>
          </div>
        </div>
        </>
    )
}